export const isVideoSource = (src) => {
  if (!src) return false;
  if (src.startsWith("data:video/")) return true;
  return /\.(mp4|webm|mov|avi|mkv|ogg)(\?|$)/i.test(src);
};
